var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79045 11.8337C9.09986 11.8337 9.39661 11.7107 9.6154 11.4919C9.8342 11.2732 9.95711 10.9764 9.95711 10.667V7.75033L7.04045 10.0837V8.33366H2.95711V7.16699H7.04045V5.41699L9.95711 7.75033V3.66699L6.45711 0.166992H1.79045C1.48103 0.166992 1.18428 0.289908 0.965488 0.508701C0.746696 0.727493 0.623779 1.02424 0.623779 1.33366V10.667C0.623779 10.9764 0.746696 11.2732 0.965488 11.4919C1.18428 11.7107 1.48103 11.8337 1.79045 11.8337H8.79045ZM5.87378 1.33366L8.79045 4.25033H5.87378V1.33366Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExport);
export default __webpack_public_path__ + "static/media/ic_export.e7ed5f26ea7af0662f3fa0172c6ea813.svg";
export { ForwardRef as ReactComponent };